import {
  getFindVenueOverviewVersionQueryKey,
  useUpdateVenueOverviewVersion,
} from '@api';
import { useInvalidateQuery, useNotification } from '@common';
import { AxiosError } from 'axios';
import { VenueInhouseTicketSystemFormDataType } from '../useVenueInhouseTicketSystemFormSchema';

const TRANS_PATH = 'NOTIFICATIONS.UPDATE_VENUE_INHOUSE_TICKET_SYSTEM';

type UseUpdateVenueInhouseTicketSystemReturnType = {
  updateVenueInhouseTicketSystem: (
    data: VenueInhouseTicketSystemFormDataType
  ) => Promise<void>;
};

type UseUpdateVenueInhouseTicketSystemPropsType = {
  venueId: string;
  overviewVersion: string;
  onClose: () => void;
};

export const useUpdateVenueInhouseTicketSystem = ({
  venueId,
  overviewVersion,
  onClose,
}: UseUpdateVenueInhouseTicketSystemPropsType): UseUpdateVenueInhouseTicketSystemReturnType => {
  const { mutateAsync } = useUpdateVenueOverviewVersion();
  const { showSuccess, showError } = useNotification();

  const { invalidateQuery } = useInvalidateQuery(
    getFindVenueOverviewVersionQueryKey(venueId, overviewVersion)
  );

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH}.SUCCESS.TITLE`,
      message: `${TRANS_PATH}.SUCCESS.MESSAGE`,
    });
    invalidateQuery();
    onClose();
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH}.ERROR.TITLE`,
      message: `${TRANS_PATH}.ERROR.MESSAGE`,
      error,
    });
  };

  const updateVenueInhouseTicketSystem = async (
    data: VenueInhouseTicketSystemFormDataType
  ): Promise<void> => {
    await mutateAsync(
      {
        venueId,
        overviewVersion,
        data: { inhouseTicketSystem: data },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { updateVenueInhouseTicketSystem };
};
